
const mantenedorTrabajadoresAchsState = {
  isLoading: false,
  listaTrabajadores: [],
  listaRoles:[],
  dataRolesUserSelected: null
};

export default mantenedorTrabajadoresAchsState;
